module.exports = {
	"data": {
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"excerpt": "",
						"id": "/Users/dschau/Code/Personal/gatsby-images-issue-example/src/pages/07-14-2017-sample-issue/index.md absPath of file >>> MarkdownRemark",
						"frontmatter": {
							"title": "Sample Issue",
							"date": "July 14, 2017",
							"path": "/sample-issue.html"
						}
					}
				}
			]
		}
	},
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/index.json
// module chunks = 4